var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseMobileNav = function SvgCloseMobileNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "close-mobile-nav_svg__a",
    d: "M0 0h44v44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "close-mobile-nav_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close-mobile-nav_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close-mobile-nav_svg__a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#close-mobile-nav_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.686 13.1 1.415-1.414L33.314 32.9l-1.415 1.415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.9 11.686 1.414 1.415L12.1 34.314l-1.415-1.415z"
  })))));
};
export default SvgCloseMobileNav;